import { defineComponent as _defineComponent } from 'vue'
import { ClientBusinessIndustry } from "@/gql"
import { useUtilities } from "@/hooks/useUtilities"
import { computed, ref, watch } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'IndustriesSelect',
  props: {
    defaultValue: null
  },
  emits: ["update:modelValue", "input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:modelValue", value: ClientBusinessIndustry | null): void
  (e: "input", value: ClientBusinessIndustry | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  defaultValue: ClientBusinessIndustry | null
}





const value = ref<ClientBusinessIndustry | null>(props.defaultValue)

watch(value, (newValue) => {
  emit("update:modelValue", newValue)
  emit("input", newValue)
})

const { snakeCaseTextFormat } = useUtilities()

const industryItems = computed(() => {
  return Object.values(ClientBusinessIndustry).map((value) => ({
    label: snakeCaseTextFormat(value),
    value: value,
  }))
})

return { __sfc: true,emit, props, value, snakeCaseTextFormat, industryItems }
}

})